/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import Sidebar from "components/sidebar/sidebar";
import { t } from "i18n";
import Menu from "components/menu/menu";
import menuItems from "./menu-items";
import { match } from "react-router";
import { Features } from "api/route-data/route-data";

interface StateProps {
  isTaskPlannerEnabled?: boolean;
}

interface PartialAppState {
  features: Features;
}

type Props = StateProps & {
  match: match;
  isBannerPresent: boolean;
};

export class UserSidebar extends React.Component<Props> {
  render() {
    return (
      <Sidebar isBannerPresent={this.props.isBannerPresent}>
        <Menu
          items={menuItems(this.props.isTaskPlannerEnabled)}
          getItemLabel={(item) => item.label}
          routeTo={(item) => item.path}
          isItemSelected={(item) => item.path === this.props.match.path}
          title={t("user-page.sidebar.title")}
        />
      </Sidebar>
    );
  }
}

const mapStateToProps = (state: PartialAppState): StateProps => {
  return {
    isTaskPlannerEnabled: state.features.isTaskPlannerEnabled
  };
};

export default compose(connect(mapStateToProps))(UserSidebar);
